function dataConvert(input) {
    var d = new Date(input);
    var year = d.getFullYear();
    var month = d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : "" + (d.getMonth() + 1);
    var day = d.getDate() < 10 ? "0" + d.getDate() : "" + d.getDate();
    var hour = d.getHours() < 10 ? "0" + d.getHours() : "" + d.getHours();
    var minutes = d.getMinutes() < 10 ? "0" + d.getMinutes() : "" + d.getMinutes();
    var seconds = d.getSeconds() < 10 ? "0" + d.getSeconds() : "" + d.getSeconds();
    return (year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds);
}
function dataConvert2(input) {
    var d = new Date(input);
    var year = d.getFullYear();
    var month = d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : "" + (d.getMonth() + 1);
    var day = d.getDate() < 10 ? "0" + d.getDate() : "" + d.getDate();
    return (year + "-" + month + "-" + day );
}
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}


const USER_KEY = "userInfo";
const TOKEN='token';
const IDENTITY='identity';
 // 获取微信token
 function getToken() {
  return sessionStorage.getItem(TOKEN);
}
//保存用户token
 function setToken(token) {
  sessionStorage.setItem(TOKEN, token);
}
 // 获取用户身份
 function getIdentity() {
  return sessionStorage.getItem(IDENTITY);
}
//保存用户身份
 function setIdentity(identity) {
  sessionStorage.setItem(IDENTITY, identity);
}

function setItem(key,value) {
  sessionStorage.setItem(key, value);
}
function getItem(key) {
  return sessionStorage.getItem(key);
}

 // 获取用户信息
function getUser() {
  return JSON.parse(sessionStorage.getItem(USER_KEY));
}
//保存用户信息
function setUser(userinfo) {
  sessionStorage.setItem(USER_KEY, JSON.stringify(userinfo));
}

 export default {
    getQueryString,
	dataConvert2,
    dataConvert,
	getUser,
	setUser,
	setToken,
    getToken,
	getIdentity,
	setIdentity,
	setItem,
	getItem
 }